import React from 'react';
import Header from './Header';
import Footer from './Footer';

/**
 * A reusable page template component that includes the header and footer
 * @param {Object} props - Component props
 * @param {string} props.title - Page title
 * @param {React.ReactNode} props.children - Page content
 * @param {string} [props.heroImage] - Optional hero image URL
 * @param {string} [props.heroDescription] - Optional hero description
 */
const PageTemplate = ({ title, children, heroImage, heroDescription }) => {
  return (
    <div className="page">
      <Header />

      {heroImage && (
        <div className="hero about-hero" style={{
          backgroundImage: `linear-gradient(135deg, rgba(52, 152, 219, 0.85) 0%, rgba(39, 174, 96, 0.85) 100%), url(${heroImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          color: 'white'
        }}>
          <div className="hero-content">
            <h1 className="hero-title">{title}</h1>
            {heroDescription && <p className="hero-description">{heroDescription}</p>}
          </div>
        </div>
      )}

      {!heroImage && (
        <div className="hero about-hero" style={{
          background: `linear-gradient(135deg, rgba(52, 152, 219, 0.85) 0%, rgba(39, 174, 96, 0.85) 100%)`,
          color: 'white'
        }}>
          <div className="hero-content">
            <h1 className="hero-title">{title}</h1>
            {heroDescription && <p className="hero-description">{heroDescription}</p>}
          </div>
        </div>
      )}

      <main className="container section">
        {children}
      </main>

      <Footer />
    </div>
  );
};

export default PageTemplate;
